export default __webpack_public_path__ + "static/media/tutory.40238188.png";